import { File } from '../models/File'
import { Observable } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { IFileApi } from '../api/FileApi'
import { Query } from '../../../common/api/Query'
import { IStatusService } from '../../../common/status/StatusService'
import { FileDTO } from '../models/FileDTO'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { ItemList } from '../../../common/models/ItemList'

type Props = {
  apiKey: symbol
}

export interface IFileService extends IInit {
  getByID(id: string): Observable<File | undefined>

  getProfilePhotoByUserID(ownerID: string | undefined): Observable<File | undefined>

  getFilteredItems(q: Query<File>): Observable<ItemList<File>>

  add(e: FileDTO): Observable<File | undefined>

  addProfilePhoto(e: FileDTO): Observable<File | undefined>

  update(e: FileDTO): Observable<File | undefined>

  delete(id: string): Observable<boolean>
}

export class FileService implements IFileService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IFileApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IFileApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getByID(id: string | null): Observable<File | undefined> {
    return this._api.getByID(id)
  }

  getProfilePhotoByUserID(ownerID: string | undefined): Observable<File | undefined> {
    return this._api.getProfilePhotoByUserID(ownerID)
  }

  getFilteredItems(q: Query<File>): Observable<ItemList<File>> {
    return this._api.getFilteredItems(q).pipe()
  }

  add(e: FileDTO): Observable<File | undefined> {
    return this._api.add(e)
  }

  addProfilePhoto(e: FileDTO): Observable<File | undefined> {
    return this._api.addProfilePhoto(e)
  }

  update(e: FileDTO): Observable<File | undefined> {
    return this._api.update(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }
}
